import React, { FunctionComponent } from 'react';

import { HideFromScreenReaderProps } from '@components/library/screen-reader';
import { BaseScreenReader } from '../base';

export const HideFromScreenReader: FunctionComponent<HideFromScreenReaderProps> = (
  props
) => <BaseScreenReader {...props} aria-hidden variantName="hide-from" />;
